// extracted by mini-css-extract-plugin
export default {"container":"join-board_container__uyPoq","card":"join-board_card__O32r9","header":"join-board_header__o9H2U","body":"join-board_body__zHDyJ"};